React = require('react');
ReactDOM = require('reactDOM');

class AlertError extends React.Component {
    render () {
        return <div className="alert alert-danger">{this.props.message}</div>;
    }
}


class RelatedRelactionsBlock extends React.Component {
    constructor(props) {
        super(props);
        this.resultsCallback = this.resultsCallback.bind(this);
        this.state = {hide:false};
    }

    resultsCallback(result) {
        this.setState({hide: (result === null || result.resultCount === 0)});
    }

    render() {
        return (
            <div className={'panel panel-default block-related-reactions' + (this.state.hide ? ' hidden' : '')}>
                <div className='panel-heading'>
                    <h3 className='panel-title'>
                        <a href={this.props.attrs.link} dangerouslySetInnerHTML={{__html:this.props.attrs.title}} />
                    </h3>
                </div>
                <div className='panel-body'>
                    <SearchResultsTable attrs={this.props.attrs} no_results_behaviour="hide" resultsCallback={this.resultsCallback} />
                </div>
            </div>
        );
    }
}


class SearchResultsTable extends  React.Component {
    constructor(props) {
        super(props);
        this.updateRows = this.updateRows.bind(this);
        this.state = {
            error: null,
            isLoaded: false,
            offset:0,
            result: null
        };
    }

    componentDidMount() {
        getTranslations()
            .then(this.updateRows);
    }

    updateRows() {
        this.setState({isLoaded: false, result: null, error: null});
        fetch(`${this.props.attrs.basepath}api/search-reactions-by-compound-ids?reactantIds=${this.props.attrs.reactantids}&productIds=${this.props.attrs.productids}&offset=${this.state.offset}`)
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        error: null,
                        result
                    });
                    if (this.props.resultsCallback) {
                        this.props.resultsCallback(result);
                    }
                },
                (error) => {
                    this.setState({
                        isLoaded: false,
                        result: null,
                        error
                    });
                }
            )
    }

    buttonClicked(offset,e) {
        e.preventDefault();
        this.setState({offset}, this.updateRows);
    }

    render() {
        const {error, isLoaded, result} = this.state;
        if (error) {
            return <AlertError message={error.message} />;
        } else if (!isLoaded) {
            return (
                <h1 style={{display: "inline-block", margin: "30px 0 30px 0"}}>
                    <i className='glyphicon glyphicon-refresh spin'/>
                </h1>
            )
        } else if (result.resultCount === 0) {
            if (this.props.no_results_behaviour !== 'hide') {
                return <AlertError message={translate('no_results_found')} />;
            } else {
                return null;
            }
        } else {
            let thead = null;
            let tfoot = null;
            if (result.resultCount > result.limit) {
                let children = [];
                for (let page = 1, offset = 0; offset < result.resultCount; offset += result.limit, page++) {
                    if (page > 10) {
                        children.push(<li key={page}><a>...</a></li>);
                        break;
                    }
                    children.push(
                        <li key={page} className={offset === result.offset ? 'active' : ''}>
                            <a className="page-link" onClick={this.buttonClicked.bind(this,offset)} href="#">{page}</a>
                        </li>
                    );
                }
                let pagination = <ul className="pagination pagination-sm">{children}</ul>;

                thead = (
                    <thead>
                        <tr><td colSpan="2">{pagination}</td></tr>
                    </thead>
                );
                tfoot = (
                    <tfoot>
                        <tr><td colSpan="2">{pagination}</td></tr>
                    </tfoot>
                )
            }

            return (
                <table className="table search-results">
                    {thead}
                    <tbody>
                    {result.searchResults.map((searchResult,i) => (
                        <tr key={i}><td>{result.offset+i+1}</td><td><a href={this.props.attrs.basepathlan + "?s=" + encodeURIComponent(searchResult.equationStr) + "&ref=search"} dangerouslySetInnerHTML={{__html:searchResult.equationStrBold}} /></td></tr>
                    ))}
                    </tbody>
                    {tfoot}
                </table>
            );
        }
    }
}


$('.search-results-async').each((i,obj) => ReactDOM.render(<SearchResultsTable attrs={obj.dataset} />, obj));
$('.related-reactions-block-async').each((i,obj) => ReactDOM.render(<RelatedRelactionsBlock attrs={obj.dataset} />, obj));